import React from "react";
import { Link } from "react-router-dom";

import { FlexCenter } from "../../styles";
import {
  deliveryIcon,
  fbSvg,
  giftFooterSvg,
  instaFooter,
  linkedInSvg,
  mailFooterSvg,
  phoneFooterSvg,
  pieIcon,
  pointSvg,
  strangeCircle,
  tiktokSvg,
  youtubeSvg,
} from "../../svgs";

import {
  MainFooter,
  FooterMain,
  FooterCol,
  FooterBottom,
  FooterCategoies,
  ContainerBlock,
} from "./styled";

import CustomEmailInput from "./subscribeForm";

const Footer = () => {
  return (
    <>
      <MainFooter>
        <ContainerBlock>
          <FooterMain>
            <FooterCol>
              <div className="heading">ჩვენ შესახებ</div>

              <a href="https://veli.store/info/manifest">მანიფესტი</a>
              <a href="https://veli.store/business">ბიზნესი</a>
              <a href="https://veli.store/info/delivery">მიწოდება</a>

              <a href="https://veli.store/info/news">მიმდინარე შეთავაზებები</a>
              <a href="https://veli.store/faq">FAQ</a>
            </FooterCol>

            <FooterCol>
              <div className="heading">წესები & პირობები</div>

              <a href="https://veli.store/info/terms-and-conditions/">
                წესები & პირობები
              </a>
              <a href="https://veli.store/info/privacy-policy">
                კონფიდენციალურობა
              </a>
              <a href="https://veli.store/info/return-policy">დაბრუნება</a>
              <a href="https://veli.store/info/instalment">განვადება</a>
            </FooterCol>

            <FooterCol>
              <div className="heading">რატომ ველი?</div>

              <div className="text-row">
                {deliveryIcon()}
                <p>უფასო მიწოდება ყველგან</p>
              </div>
              <div className="text-row">
                {strangeCircle()}
                <p>თბილისში მიტანა 3 საათში</p>
              </div>
              <div className="text-row">
                {pointSvg()}
                <p>მიტანის დროის არჩევანი</p>
              </div>
              <div className="text-row">
                {giftFooterSvg()}
                <p>უფასო სასაჩუქრე შეფუთვა</p>
              </div>
              <div className="text-row">
                {pieIcon()}
                <p>0% ეფექტური განვადება</p>
              </div>
            </FooterCol>

            <FooterCol>
              <div className="heading">კონტაქტი</div>

              <div className="item-row row">
                <Link to="tel:0322560505">
                  <FlexCenter>{phoneFooterSvg()}</FlexCenter>
                  032 2 56 05 05
                </Link>
                <Link to="mailto:support@veli.store">
                  <FlexCenter>{mailFooterSvg()}</FlexCenter>
                  support@veli.store
                </Link>
              </div>

              <div className="icon-row row">
                <a
                  target="blank"
                  href="https://www.facebook.com/Veli-ველი-100164965737068"
                >
                  <FlexCenter>{fbSvg()}</FlexCenter>
                </a>
                <a target="blank" href="https://www.instagram.com/veli.store/">
                  <FlexCenter>{instaFooter()}</FlexCenter>
                </a>
                <a
                  target="blank"
                  href="https://www.youtube.com/channel/UCJOUWeSt2AAz9RWGJ518NpQ"
                >
                  <FlexCenter>{youtubeSvg()}</FlexCenter>
                </a>

                <a
                  target="blank"
                  href="https://www.linkedin.com/company/veli-store"
                >
                  <FlexCenter>{linkedInSvg()}</FlexCenter>
                </a>

                <a
                  target="blank"
                  href="https://www.tiktok.com/@veli_store?_t=8Wey4HJuTY2&_r=1"
                >
                  <FlexCenter>{tiktokSvg()}</FlexCenter>
                </a>
              </div>

              <div className="mail-input">
                <CustomEmailInput />
              </div>
              {/* --- */}
            </FooterCol>

            <div className="icon-row-mob row">
              <a
                target="blank"
                href="https://www.facebook.com/Veli-ველი-100164965737068"
              >
                <FlexCenter>{fbSvg()}</FlexCenter>
              </a>
              <a target="blank" href="https://www.instagram.com/veli.store/">
                <FlexCenter>{instaFooter()}</FlexCenter>
              </a>
              <a
                target="blank"
                href="https://www.youtube.com/channel/UCJOUWeSt2AAz9RWGJ518NpQ"
              >
                <FlexCenter>{youtubeSvg()}</FlexCenter>
              </a>

              <a
                target="blank"
                href="https://www.linkedin.com/company/veli-store"
              >
                <FlexCenter>{linkedInSvg()}</FlexCenter>
              </a>

              <a
                target="blank"
                href="https://www.tiktok.com/@veli_store?_t=8Wey4HJuTY2&_r=1"
              >
                <FlexCenter>{tiktokSvg()}</FlexCenter>
              </a>
            </div>
            <div className="mobile-input">
              <CustomEmailInput />
            </div>
          </FooterMain>
        </ContainerBlock>
      </MainFooter>

      <FooterCategoies>
        <ContainerBlock>
          <div className="links-row">
            <FooterCol>
              <div className="heading-2">სამზარეულოს ტექნიკა</div>
              <a
                href={`https://veli.store/category/teqnika/samzareulos-teqnika/tsvensatsurebi/1466/`}
              >
                წვენსაწურები
              </a>
              <a
                href={`https://veli.store/category/teqnika/samzareulos-teqnika/ingredientebis-momzadeba-damushaveba/blenderebi/1469/`}
              >
                ბლენდერები
              </a>

              <a
                href={`https://veli.store/category/teqnika/samzareulos-teqnika/ingredientebis-momzadeba-damushaveba/miqserebi/3062/`}
              >
                მიქსერები
              </a>
              <a
                href={`https://veli.store/category/teqnika/samzareulos-teqnika/eleqtro-ghumelebi-da-aerogrilebi/1463/`}
              >
                ღუმელები & გრილები
              </a>
            </FooterCol>
            <FooterCol>
              <div className="heading-2">პოპულარული ბრენდები</div>
              <a href="https://veli.store/category/teqnika/dyson/4959/">
                დაისონი
              </a>

              <a href={`https://veli.store/category/teqnika/apple/2458/`}>
                ეფლი
              </a>

              <a href={`https://veli.store/category/kikkerland/1866/`}>
                Kikkerland
              </a>

              <a href={`https://veli.store/category/pylones/4641/`}>Pylones</a>
            </FooterCol>
            <FooterCol>
              <div className="heading-2">აუდიო ტექნიკა</div>
              <a
                href={`https://veli.store/category/teqnika/audioteqnika/yursasmenebi/782/`}
              >
                ურსასმენები
              </a>

              <a
                href={`https://veli.store/category/teqnika/audioteqnika/yursasmenebi/782/?filter_options=4525`}
              >
                უსადენო ყურსასმენები
              </a>

              <a
                href={`https://veli.store/category/teqnika/audioteqnika/dinamikebi/779/`}
              >
                დინამიკები
              </a>

              <a
                href={`https://veli.store/category/teqnika/audioteqnika/firsakravebi/1327/`}
              >
                ფირსაკრავები
              </a>
            </FooterCol>
            <FooterCol>
              <div className="heading-2">ტექნიკა</div>

              <a
                href={`https://veli.store/category/teqnika/televizorebi-aqsesuarebi/televizorebi/2837/`}
              >
                ტელევიზორები
              </a>

              <a
                href={`https://veli.store/category/teqnika/sakhli-da-dasuftaveba/mtversasrutebi/1549/`}
              >
                მტვერსასრუტები
              </a>

              <a
                href={`https://veli.store/category/teqnika/kompiuteruli-teqnika/leptopebi/783/`}
              >
                ლეპტოპები
              </a>

              <a
                href={`https://veli.store/category/teqnika/mobilurebi-aqsesuarebi/mobiluri-telefonebi/60/`}
              >
                მობილური ტელეფონები
              </a>
            </FooterCol>
            <FooterCol>
              <div className="heading-2">სილამაზე & მოვლა</div>

              <a
                href={`https://veli.store/category/silamaze-movla/koreuli-kosmetika/2407/`}
              >
                ორეული კოსმეტიკა
              </a>

              <a
                href={`https://veli.store/category/silamaze-movla/sunamoebi/186/`}
              >
                სუნამოები
              </a>
              <a
                href={`https://veli.store/category/silamaze-movla/sasachuqre-nakrebebi/191/`}
              >
                სასაჩუქრე ნაკრებები
              </a>

              <a
                href={`https://veli.store/category/silamaze-movla/tmis-movla/184/`}
              >
                თმის მოვლა
              </a>

              <a
                href={`https://veli.store/category/silamaze-movla/sakhis-kanis-movla/tsveris-movla/524/`}
              >
                წვერის მოვლა
              </a>
            </FooterCol>
          </div>

          <FooterBottom>
            <div className="store-row">
              <a
                target="blank"
                href="https://apps.apple.com/us/app/veli-store/id6444022953"
              >
                <img
                  id="app-btn"
                  // src="./images/app-store.png"
                  src="https://veli.store/icons/app-store.png"
                  alt="app-store.png"
                />
                {/* App Store */}
              </a>
              <a
                target="blank"
                href="https://play.google.com/store/apps/details?id=com.veliapp"
              >
                <img
                  id="play-btn"
                  // src="./images/play-store.png"
                  src="https://veli.store/icons/play-store.png"
                  alt="play-store.png"
                />
                {/* Google Play */}
              </a>
            </div>

            <p>
              Copyright &copy; {new Date().getFullYear()} Veli.store, ყველა
              უფლება დაცულია.
            </p>
          </FooterBottom>
        </ContainerBlock>
      </FooterCategoies>
    </>
  );
};
export default Footer;
